import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  InputAdornment,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import LogoImg from "../../../../../assets/logo.png";
import RHFTextField from "../../../../../components/rhf-textField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import useWidth from "../../../../../hooks/useSize";
import { toast } from "react-toastify";
import { useRedirectUrl } from "../../../../../hooks/Authorize";
import { signInWithPopup, signOut } from "firebase/auth";
import {
  auth,
  facebookProvider,
  googleProvider,
} from "../../../../../utilities/firebase.config";
import { FcGoogle } from "react-icons/fc";
import { FacebookTwoTone } from "@mui/icons-material";
import {
  setCookie,
  clearCookie,
  getCookie,
} from "../../../../../utilities/cookies";
import { Divider } from "@mui/material";

const API_BASE_URL = "https://accounts.wurknest.com:6050/api";

const generateRandomPassword = (length = 12) => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=";
  try {
    const randomValues = new Uint32Array(length);
    window.crypto.getRandomValues(randomValues);
    return Array.from(randomValues)
      .map((v) => charset[v % charset.length])
      .join("");
  } catch (e) {
    let res = "";
    for (let i = 0; i < length; i++) {
      res += charset[Math.floor(Math.random() * charset.length)];
    }
    return res;
  }
};

const withSuppressedFirebasePopupAssertion = async (fn) => {
  const handler = (ev) => {
    try {
      const r = ev.reason;
      const msg = r && (r.message || r.code || String(r));
      if (
        (typeof msg === "string" &&
          msg.includes("Pending promise was never set")) ||
        (r && r.code === "auth/popup-closed-by-user")
      ) {
        ev.preventDefault();
        console.warn(
          "Suppressed firebase unhandled rejection during popup:",
          r
        );
      }
    } catch (suppressErr) {}
  };

  window.addEventListener("unhandledrejection", handler);
  try {
    return await fn();
  } finally {
    window.removeEventListener("unhandledrejection", handler);
  }
};

const Login = () => {
  const width = useWidth();
  const navigate = useNavigate();
  const redirectUrl = useRedirectUrl();
  const queryParameters = new URLSearchParams(window.location.search);
  const redirectto = queryParameters.get("redirectto");
  const [anchorElCreate, setAnchorElCreate] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleCreateClick = (event) => {
    setAnchorElCreate(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElCreate(null);
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(/^[a-zA-Z0-9]+$/, "Only numbers & alphabets are allowed")
      .min(2)
      .max(25)
      .required("Required Field"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, action) => {
      // Create FormData object and append email field
      var formData = new FormData();
      formData.append("email", values.email + "@wurkmail.com");

      //formData.append("password", values.password);
      pushToServer(formData);
      // Reset the form and navigate after submission
      localStorage.setItem("formData", JSON.stringify(values));
      action.resetForm();
      // navigate("/login_2");
    },
  });
  const pushToServer = async (formData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/auth/login_email`,
        //process.env.REACT_APP_BASE_URL+"/api/auth/login_email",
        // "https://accounts.wurknest.com:6050/api/auth/login_email",
        {
          method: "POST",
          body: formData,
        }
      );

      // if (!response.ok) {
      //   throw new Error("Network response was not ok");
      // }

      const responseData = await response.json();
      if (responseData.success) {
        console.log("redirectUrl login", redirectUrl);
        redirectUrl && redirectUrl !== ""
          ? navigate("/login_2" + "?redirectto=" + redirectUrl)
          : navigate("/login_2");
      } else {
        // setErrorMessage(responseData.error);
        toast.error(responseData.error);
        console.error(responseData.error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const styles = {
    loginWrap: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      color: "#fff",
      height: "100dvh",
      padding: "0px 8px",
    },
    loginContent: {
      maxWidth: width > 768 ? "448.8px" : "100%",
      height: width > 768 ? "600px" : "100%",
      border: width > 768 ? "1px solid #8C8C8C" : "none",
      borderRadius: width > 768 ? "12px" : "none",
      // boxShadow:
      //   width > 768 ? "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" : "none",
      px: "35px",
      py: "35px",
      backgroundColor: "#121212",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    formWrapper: {
      paddingTop: "30px",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignContent: "space-between",
      flexDirection: "column",
    },
    heading: {
      fontSize: "24px",
      fontWeight: 600,
    },
    label: {
      fontSize: "16px",
      fontWeight: 400,
      color: "#f5f4f4",
      py: 1,
    },
    emailInputAdornment: {
      fontSize: "13px",
      color: "#605f5f",
      fontWeight: 600,
      letterSpacing: 0.8,
      pt: 0.5,
    },
    forgotPassword: {
      color: "#1470B6",
      fontWeight: 700,
      fontSize: "14px",
      textDecoration: "none",
    },
    register: {
      color: "#1470B6",
      fontWeight: 700,
      fontSize: "14px",
      textDecoration: "none",
    },
    button: {
      backgroundColor: "#1472b8",
      padding: "6px 16px",
      color: "#fff",
      borderRadius: "4px",
      fontSize: "0.875rem",
      fontWeight: 600,
      textTransform: "uppercase",
      "&:hover": {
        background: "#1472b8",
      },
    },
    desc: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#7e7878",
      py: 1,
      px: 2,
    },
  };

  const [loadding, setLoadding] = useState(false);

  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const [tokens, setTokens] = useState(null);
  const popupInProgress = useRef(false);

  const handleSocialLogin = async (provider) => {
    if (popupInProgress.current) {
      console.warn("Popup already in progress, ignoring duplicate click.");
      return;
    }
    popupInProgress.current = true;
    setLoadding(true);
    setError("");

    try {
      let result;
      let providerName;
      let authProvider;

      if (provider === "google") {
        authProvider = googleProvider;
        providerName = "google";
      } else if (provider === "facebook") {
        authProvider = facebookProvider;
        providerName = "facebook";
      } else {
        throw new Error("Invalid provider");
      }

      try {
        result = await withSuppressedFirebasePopupAssertion(() =>
          signInWithPopup(auth, authProvider)
        );
      } catch (firebaseErr) {
        console.error(
          "Firebase popup error:",
          firebaseErr?.code,
          firebaseErr?.message
        );
        if (
          firebaseErr?.code === "auth/popup-closed-by-user" ||
          firebaseErr?.code === "auth/cancelled-popup-request" ||
          firebaseErr?.code === "auth/popup-blocked"
        ) {
          console.log("Login cancelled by user");
          return;
        }
        throw firebaseErr;
      }

      const idToken = await result.user.getIdToken();

      const response = await fetch(`${API_BASE_URL}/auth/socialLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idToken,
          provider: providerName,
          login_app: "Wurknest Accounts",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Social login failed");
      }

      // Second API hit: Register/Sync user
      const randomPassword = generateRandomPassword(14);
      const displayName = result.user.displayName || "";
      const firstNameFromDisplay = displayName ? displayName.split(" ")[0] : "";
      const lastNameFromDisplay = displayName
        ? displayName.split(" ").slice(1).join(" ")
        : "";

      const signupData = {
        userName:
          // result.user.username is usually undefined from Firebase, so fallback logic is key
          (result.user.email
            ? result.user.email.split("@")[0]
            : firstNameFromDisplay.toLowerCase()) || "",
        firstName: firstNameFromDisplay || "",
        lastName: lastNameFromDisplay || "",
        email: result.user.email || "",
        password: randomPassword,
      };

      try {
        const regRes = await fetch(`https://api.projects.wurknest.com:6550/api/v2/auth/register`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(signupData),
        });
        const regData = await regRes.json();
        console.log("Register succeeded:", regData);
      } catch (regErr) {
        console.warn(
          "Register failed but continuing to redirect:",
          regErr.message || regErr
        );
      }

      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("sessionToken", data.sessionToken);
        localStorage.setItem("user", JSON.stringify(data.user));

        console.log("redirectUrl login 2", redirectUrl);
        setCookie("user", data.user);
        const currentUser = data.user;

        if (redirectUrl && redirectUrl !== "" && redirectUrl !== "null") {
          // console.log('redirect',redirectto)
          clearCookie("redirectto");

          // window.location.replace('https://localhost:3001/dashboard');
          return window.location.replace(
            redirectUrl +
              "userId=" +
              currentUser._id +
              "&refreshToken=" +
              data.refreshToken
          );
        } else {
          // navigate("/");
          window.location.replace("https://wurknest.com/");
        }
        // console.log("Login successful:", data.user);
      }
    } catch (error) {
      console.error("Social login error:", error);
      setError(error.message || "An error occurred during login");

      try {
        if (error?.code !== "auth/popup-closed-by-user") {
          await signOut(auth);
        }
      } catch (signOutError) {
        console.error("Sign out error:", signOutError);
      }
    } finally {
      setLoadding(false);
      popupInProgress.current = false;
    }
  };

  return (
    <Box sx={styles.loginWrap}>
      <Box sx={styles.loginContent}>
        <Box sx={{ textAlign: "center" }}>
          <img
            src={LogoImg}
            alt="Logo"
            style={{ width: width > 768 ? "8%" : "12%" }}
          />
        </Box>
        <Box sx={{ pt: 2, textAlign: "center" }}>
          <Typography component="h2" sx={styles.heading}>
            Log In
          </Typography>
          <Box display="flex" flexDirection="column" gap={2} width="100%">
            <Button
              fullWidth
              variant="outlined"
              disabled={loadding}
              onClick={() => handleSocialLogin("google")}
              startIcon={<FcGoogle size={22} />}
              sx={{
                borderRadius: "9999px",
                textTransform: "none",
                fontWeight: 500,
                py: { xs: 1, md: 1.5 },
                px: { xs: 1.5, md: 2 },
                fontSize: { xs: "0.875rem", md: "0.875rem" },
                color: "text.primary",
                "&:hover": {
                  bgcolor: "action.hover",
                },
              }}
            >
              Continue with Google
            </Button>

            <Button
              fullWidth
              variant="outlined"
              disabled={loadding}
              onClick={() => handleSocialLogin("facebook")}
              startIcon={<FacebookTwoTone sx={{ color: "#1877f2" }} />}
              sx={{
                borderRadius: "9999px",
                textTransform: "none",
                fontWeight: 500,
                py: { xs: 1, md: 1.5 },
                px: { xs: 1.5, md: 2 },
                fontSize: { xs: "0.875rem", md: "0.875rem" },
                color: "text.primary",
                "&:hover": {
                  bgcolor: "action.hover",
                },
              }}
            >
              Continue with Facebook
            </Button>

            <Box display="flex" alignItems="center" width="100%" my={2}>
              <Box flexGrow={1}>
                <Divider />
              </Box>
              <Typography
                variant="body2"
                sx={{ mx: { xs: 1.5, md: 2 }, color: "text.secondary" }}
              >
                OR
              </Typography>
              <Box flexGrow={1}>
                <Divider />
              </Box>
            </Box>
          </Box>
          <Typography component="h4" sx={styles.label}>
            Use your Wurknest Account
          </Typography>
          <form style={styles.formWrapper} onSubmit={formik.handleSubmit}>
            <Box>
              <RHFTextField
                formik={formik}
                name="email"
                placeholder="Enter Email"
                type="text"
                inputPorps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={styles.emailInputAdornment}>
                        @wurkmail.com
                      </Typography>
                    </InputAdornment>
                  ),
                }}
              />
              <span style={{ color: "red" }}>{errorMessage}</span>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pt: 2,
                }}
              >
                <Link to="/forgot-mail-email" style={styles.forgotPassword}>
                  Forgot Mail?
                </Link>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pt: 2.8,
                }}
              >
                <div>
                  <Button
                    aria-controls="create-menu"
                    aria-haspopup="true"
                    onClick={handleCreateClick}
                    variant="text"
                    style={styles.register}
                  >
                    Create Account
                  </Button>
                  <Menu
                    id="create-menu"
                    anchorEl={anchorElCreate}
                    open={Boolean(anchorElCreate)}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                  >
                    {/* Create Account Menu Items */}
                    <Link
                      style={{
                        textDecoration: "none",
                        color: "#fff",
                      }}
                      to="/register"
                      rel="noopener"
                    >
                      <MenuItem onClick={handleClose}>Personal</MenuItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none", color: "#fff" }}
                      to="/register-business"
                      rel="noopener"
                    >
                      <MenuItem onClick={handleClose}>Business</MenuItem>
                    </Link>
                  </Menu>
                </div>

                {/* Login Button */}
                <Button type="submit" sx={styles.button}>
                  next
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
      <Box style={{ textAlign: "center" }}>
        <Typography component="p" sx={styles.desc}>
          Enter the AI realm with us, or join us with your login
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
